/**
 * Event name constants for tracking platforms
 */
export const EventNames = {
  // Page events
  PAGE_VIEWED: "Page Viewed",

  // Interaction events
  BUTTON_CLICKED: "Button Clicked",
  FORM_SUBMITTED: "Form Submitted",

  // Product events
  PRODUCT_VIEWED: "Product Viewed",
  ADDED_TO_CART: "Added To Cart",
  REMOVED_FROM_CART: "Removed From Cart",

  // Cart events
  CART_VIEW: "Cart View",

  // Checkout events
  CHECKOUT_STARTED: "Checkout Started",
  PURCHASE_COMPLETED: "Purchase Completed",

  // Search events
  SEARCH: "Search",

  // User events
  USER_SIGNED_UP: "User Signed Up",
  USER_LOGGED_IN: "User Logged In",

  // New MoEngage events from the list
  ITEM_PURCHASED: "Item Purchased",
  ORDER_PLACED: "Order Placed",
  UPDATE_CART: "Update Cart",
  CUSTOMER_REGISTERED: "Customer Registered",
  CUSTOMER_LOGGED_IN: "Customer Logged In",
  PRODUCT_SEARCHED: "Product Searched",
  SHOPIFY_CHECKOUT_UPDATED: "Shopify - Checkout Updated",
  SHOPIFY_ABANDONED_CHECKOUT: "Shopify - Abandoned Checkout",
  SHOPIFY_ORDER_FULFILLED: "Shopify - Order Fulfilled",
  SHOPIFY_CHECKOUT_STARTED: "Shopify - Checkout Started",
  SHOPIFY_ADD_TO_CART: "Shopify - Add To Cart",
  SHOPIFY_ITEM_PURCHASED: "Shopify - Item Purchased",
  SHOPIFY_ORDER_PLACED: "Shopify - Order Placed",
  SHOPIFY_REMOVED_FROM_CART: "Shopify - Removed From Cart",
  SHOPIFY_UPDATE_CART: "Shopify - Update Cart",
  SHOPIFY_ABANDONED_CART: "Shopify - Abandoned Cart",
  SHOPIFY_ORDER_CANCELED: "Shopify - Order Canceled",
  SHOPIFY_REFUND_CREATED: "Shopify - Refund Created",
  SPINFORM_RESULT: "Spinform Result",
  COUPON_COPIED: "Coupon Copied",
  SMASHPOPS_GAME_PLAYED: "SmashPops Game Played",
  POPCOINS_CREDIT_PENDING: "Popcoins Credit Pending",
  POPCOINS_SIGNUP: "POPCOINS SIGNUP",
  POPCOINS_LOGIN: "POPCOINS LOGIN",
  POPCOINS_CREDIT_ADDED: "Popcoins Credit Added",
  POPCOINS_DEBIT_PURCHASED: "Popcoins Debit Purchased",
  POPCOINS_CREDIT_CANCELED: "Popcoins Credit Canceled",
  POPCOINS_CREDIT_REFUNDED: "Popcoins Credit Refunded",
  STARTED_CHECKOUT_GK: "Started Checkout GK",
  MOBILE_ADDED_GK: "Mobile Added GK",
  ADDRESS_SELECTED_GK: "Address Selected GK",
  ADDRESS_COMPLETED_GK: "Address Completed GK",
  PAYMENT_METHOD_SELECTED_GK: "Payment Method Selected GK",
  MULTI_ID_USER_MERGED: "MULTI ID USER MERGED",
  PAYMENT_COMPLETED_GK: "Payment Completed GK",
  ORDER_SUCCESS: "Order Success",
  ORDER_COMPLETED: "Order Completed",
  PIN_CODE_ADDED_GK: "PIN Code Added GK",
  ADDRESS_ADDED_GK: "Address Added GK",
  FLIGHT_BOOKED: "Flight Booked",
  NEW_LEAD: "New Lead",
  KP_MP_PHONE_NUMBER_LOGGED_IN: "KP MP Phone Number Logged In",
  KP_PHONE_NUMBER_LOGGED_IN: "KP Phone Number Logged In",
  KP_MP_SHOPIFY_LOGGED_IN: "KP MP Shopify Logged In",
  KP_MP_SUCCESSFULLY_LOGGED_OUT: "KP MP Successfully Logged Out",
  KP_WHATSAPP_LOGGED_IN: "KP Whatsapp Logged In",
  KP_MP_TRUECALLER_LOGGED_IN: "KP MP Truecaller Logged In",
  KP_MP_WHATSAPP_LOGGED_IN: "KP MP Whatsapp Logged In",
  KP_TRUECALLER_LOGGED_IN: "KP Truecaller Logged In",
  SHOPIFY_ORDER_PARTIALLY_FULFILLED: "Shopify - Order Partially Fulfilled",
  KP_SHOPIFY_LOGGED_IN: "KP Shopify Logged In",
  KP_SUCCESSFULLY_LOGGED_OUT: "KP Successfully Logged Out",
};

export const COOKIE_KEYS = {
  KP_MERCHANT_CONFIG: "KP_MERCHANT_CONFIG",
};

/**
 * Default currency code
 */
export const DEFAULT_CURRENCY = "INR";

export const HARDCODED_HANDLE = "ryze-gums";
